import request from "../utils/request";

export async function GetMoodfelekSettings() {
  return request.get("MobileSetting/GetMoodfelekSettings");
}

export async function UpdateMoodfelekSettings(payload) {
  let params = {
    image: payload.image,
    campaigns: payload.campaigns,
    imageEng: payload.imageEng
  };
  return request.post("MobileSetting/UpdateMoodfelekSettings", params);
}
